import React, {PropTypes} from 'react';
import Link from 'shared/Link.jsx';
import EntryCaptainDetailContainer from './EntryCaptainDetailContainer.jsx';
import EntryCoordinatorDetailContainer from './EntryCoordinatorDetailContainer.jsx';
import EntryDetailSummaryContainer from  './EntryDetailSummaryContainer.jsx';
import BalanceDetailContainer from './BalanceDetailContainer.jsx';
import EntryDetailPaymentModalContainer from './EntryDetailPaymentModalContainer.jsx';
import EntryDetailSquadChangeModalContainer from './EntryDetailSquadChangeModalContainer.jsx';
import EntryDetailEventChangeModalContainer from './EntryDetailEventChangeModalContainer.jsx';
import EntryDetailCoordinatorModalContainer from './EntryDetailCoordinatorModalContainer.jsx';
import EntryCaptainChangeFormModalContainer from './EntryCaptainChangeFormModalContainer.jsx';
import EntryCancelContainer from './EntryCancelContainer.jsx';
import EntryDetailRefundModalContainer from './EntryDetailRefundModalContainer.jsx';
import EntryDetailReactivationModalContainer from './EntryDetailReactivationModalContainer.jsx';

const EntryDetail = ({
  showSearchLink
}) => (
  <div className="animated fadeIn">
    {showSearchLink
      ? <div className="row">
          <div className="col-md-12">
            <Link
              className="btn btn-link"
              style={{paddingLeft: 0}}
              to="admin/search">
              {'Back to search results'}
            </Link>
          </div>
        </div>
    : null
    }
    <div className="row">
      <div className="col-md-12">
        <BalanceDetailContainer />
        <EntryDetailPaymentModalContainer />
      </div>
    </div>
    <div className="row">
      <div className="col-md-6">
        <EntryDetailSummaryContainer />
        <EntryDetailSquadChangeModalContainer />
        <EntryDetailEventChangeModalContainer />
        <EntryCancelContainer />
        <EntryDetailRefundModalContainer />
        <EntryDetailReactivationModalContainer />
      </div>
      <div className="col-md-6">
        <EntryCaptainDetailContainer />
        <EntryCaptainChangeFormModalContainer />
      </div>
      <div className="col-md-6">
        <EntryCoordinatorDetailContainer />
        <EntryDetailCoordinatorModalContainer />
      </div>
    </div>
  </div>
);

EntryDetail.propTypes = {
  showSearchLink: PropTypes.bool
};

EntryDetail.defaultProps = {
  showSearchLink: false
};

export default EntryDetail;



// WEBPACK FOOTER //
// ./src/features/admin/entryDetail/EntryDetail.jsx